var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatements(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    stroke: "#5E5E66",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 13,
    d: "M11.813 4.85847C11.813 3.69728 12.7597 2.75 13.9348 2.75H15.1282C16.3034 2.75 17.25 3.69728 17.25 4.85847V15.1415C17.25 16.3027 16.3034 17.25 15.1282 17.25H13.9348C12.7597 17.25 11.813 16.3027 11.813 15.1415V4.85847Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 9.85847C2.75 8.69728 3.69667 7.75 4.87179 7.75H6.06525C7.24038 7.75 8.18704 8.69728 8.18704 9.85847V15.1415C8.18704 16.3027 7.24037 17.25 6.06525 17.25H4.87179C3.69667 17.25 2.75 16.3027 2.75 15.1415V9.85847Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatements);
export default __webpack_public_path__ + "static/media/statements.77722d7d.svg";
export { ForwardRef as ReactComponent };